module.exports = __webpack_public_path__ + "fonts/BentonSansBBVA-MediumItalic.1265d716.eot";